import React from 'react'
import { SingleRadio, Row, Col, Typography, colors } from '@microfrontends/react-components'
import { ERefreshProfile } from '../../../../store'
import { Section, SectionContent, RefreshRadio } from './RefreshMyProfile.css'
import { convertDateTime } from '../../../../helpers/date'
import { useProfileSettingStore } from '../../../../store/ProfileSetting'

interface IProps {
    trans: (value: any) => string
}

export default function RefreshMyProfile({ trans }: IProps) {
    const { state, setState: dispatchSettingState } = useProfileSettingStore()
    const { isTurnOnRefresh, statusRefresh, expiredDate } = state

    const handleChangeStatus = (value: string) => {
        dispatchSettingState({
            ...state,
            statusRefresh: Number(value),
            isTurnOnRefresh: Number(value) !== 0
        })
    }

    const renderContentDate = () => {
        const refreshText = (
            <Typography name='body' size='medium' color={colors.grey[20]}>
                {trans(
                    "The profile will be automatically refreshed and will be on the top of the Employer's candidate search page until"
                )}{' '}
                {expiredDate}.
            </Typography>
        )

        const notRefreshText = (
            <Typography name='body' size='medium' color={colors.grey[20]}>
                {trans(
                    "The profile will be automatically refreshed and on top of the Employer's candidate search page within 15 days from the date of enabling the feature."
                )}
            </Typography>
        )
        return statusRefresh !== ERefreshProfile.Unset ? refreshText : notRefreshText
    }

    let currentStatusRefresh = statusRefresh
    if (!isTurnOnRefresh) {
        currentStatusRefresh = ERefreshProfile.Unset
    }

    return (
        <Section>
            <Typography name='title' size='medium' color={colors.grey[20]}>
                {trans('Refresh My Profile')}
            </Typography>
            <SectionContent>
                {renderContentDate()}
                <Row gutter={10}>
                    <Col xs={24} sm={8}>
                        <RefreshRadio checked={currentStatusRefresh === ERefreshProfile.Unset}>
                            <SingleRadio
                                checked={currentStatusRefresh === ERefreshProfile.Unset}
                                onChange={handleChangeStatus}
                                label={trans('Turn Off Refresh')}
                                name='refreshMyProfile'
                                id='0'
                                isLeftRadio
                                hoverBgOff
                                noBg
                            />
                        </RefreshRadio>
                    </Col>
                    <Col xs={24} sm={8}>
                        <RefreshRadio checked={currentStatusRefresh === ERefreshProfile.Weekly}>
                            <SingleRadio
                                checked={currentStatusRefresh === ERefreshProfile.Weekly}
                                onChange={handleChangeStatus}
                                label={trans('Refresh Weekly')}
                                name='refreshMyProfile'
                                id='2'
                                isLeftRadio
                                hoverBgOff
                                noBg
                            />
                        </RefreshRadio>
                    </Col>
                    <Col xs={24} sm={8}>
                        <RefreshRadio checked={currentStatusRefresh === ERefreshProfile.Daily}>
                            <SingleRadio
                                checked={currentStatusRefresh === ERefreshProfile.Daily}
                                onChange={handleChangeStatus}
                                label={trans('Refresh Daily')}
                                name='refreshMyProfile'
                                id='1'
                                isLeftRadio
                                hoverBgOff
                                noBg
                            />
                        </RefreshRadio>
                    </Col>
                </Row>
            </SectionContent>
        </Section>
    )
}
